/**
 * ISO 639-1 language list with English names, native names, and RTL flags.
 * Used by the add-language dialog to provide a searchable dropdown.
 */
export const LANGUAGES = [
    { code: "af", name: "Afrikaans", nativeName: "Afrikaans" },
    { code: "sq", name: "Albanian", nativeName: "Shqip" },
    { code: "am", name: "Amharic", nativeName: "አማርኛ" },
    { code: "ar", name: "Arabic", nativeName: "العربية", rtl: true },
    { code: "hy", name: "Armenian", nativeName: "Հայերեն" },
    { code: "az", name: "Azerbaijani", nativeName: "Azərbaycan" },
    { code: "eu", name: "Basque", nativeName: "Euskara" },
    { code: "be", name: "Belarusian", nativeName: "Беларуская" },
    { code: "bn", name: "Bengali", nativeName: "বাংলা" },
    { code: "bs", name: "Bosnian", nativeName: "Bosanski" },
    { code: "bg", name: "Bulgarian", nativeName: "Български" },
    { code: "my", name: "Burmese", nativeName: "မြန်မာ" },
    { code: "ca", name: "Catalan", nativeName: "Català" },
    { code: "zh", name: "Chinese (Simplified)", nativeName: "简体中文" },
    { code: "zh-TW", name: "Chinese (Traditional)", nativeName: "繁體中文" },
    { code: "hr", name: "Croatian", nativeName: "Hrvatski" },
    { code: "cs", name: "Czech", nativeName: "Čeština" },
    { code: "da", name: "Danish", nativeName: "Dansk" },
    { code: "nl", name: "Dutch", nativeName: "Nederlands" },
    { code: "et", name: "Estonian", nativeName: "Eesti" },
    { code: "fa", name: "Persian", nativeName: "فارسی", rtl: true },
    { code: "fi", name: "Finnish", nativeName: "Suomi" },
    { code: "fr", name: "French", nativeName: "Français" },
    { code: "gl", name: "Galician", nativeName: "Galego" },
    { code: "ka", name: "Georgian", nativeName: "ქართული" },
    { code: "de", name: "German", nativeName: "Deutsch" },
    { code: "el", name: "Greek", nativeName: "Ελληνικά" },
    { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
    { code: "ha", name: "Hausa", nativeName: "Hausa" },
    { code: "he", name: "Hebrew", nativeName: "עברית", rtl: true },
    { code: "hi", name: "Hindi", nativeName: "हिन्दी" },
    { code: "hu", name: "Hungarian", nativeName: "Magyar" },
    { code: "is", name: "Icelandic", nativeName: "Íslenska" },
    { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
    { code: "ga", name: "Irish", nativeName: "Gaeilge" },
    { code: "it", name: "Italian", nativeName: "Italiano" },
    { code: "ja", name: "Japanese", nativeName: "日本語" },
    { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
    { code: "kk", name: "Kazakh", nativeName: "Қазақ" },
    { code: "km", name: "Khmer", nativeName: "ខ្មែរ" },
    { code: "ko", name: "Korean", nativeName: "한국어" },
    { code: "ku", name: "Kurdish", nativeName: "Kurdî", rtl: true },
    { code: "lo", name: "Lao", nativeName: "ລາວ" },
    { code: "lv", name: "Latvian", nativeName: "Latviešu" },
    { code: "lt", name: "Lithuanian", nativeName: "Lietuvių" },
    { code: "mk", name: "Macedonian", nativeName: "Македонски" },
    { code: "ms", name: "Malay", nativeName: "Bahasa Melayu" },
    { code: "ml", name: "Malayalam", nativeName: "മലയാളം" },
    { code: "mt", name: "Maltese", nativeName: "Malti" },
    { code: "mr", name: "Marathi", nativeName: "मराठी" },
    { code: "mn", name: "Mongolian", nativeName: "Монгол" },
    { code: "ne", name: "Nepali", nativeName: "नेपाली" },
    { code: "no", name: "Norwegian", nativeName: "Norsk" },
    { code: "ps", name: "Pashto", nativeName: "پښتو", rtl: true },
    { code: "pl", name: "Polish", nativeName: "Polski" },
    { code: "pt", name: "Portuguese", nativeName: "Português" },
    { code: "pt-BR", name: "Portuguese (Brazil)", nativeName: "Português (Brasil)" },
    { code: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ" },
    { code: "ro", name: "Romanian", nativeName: "Română" },
    { code: "ru", name: "Russian", nativeName: "Русский" },
    { code: "sr", name: "Serbian", nativeName: "Српски" },
    { code: "si", name: "Sinhala", nativeName: "සිංහල" },
    { code: "sk", name: "Slovak", nativeName: "Slovenčina" },
    { code: "sl", name: "Slovenian", nativeName: "Slovenščina" },
    { code: "so", name: "Somali", nativeName: "Soomaali" },
    { code: "es", name: "Spanish", nativeName: "Español" },
    { code: "sw", name: "Swahili", nativeName: "Kiswahili" },
    { code: "sv", name: "Swedish", nativeName: "Svenska" },
    { code: "tl", name: "Tagalog", nativeName: "Tagalog" },
    { code: "ta", name: "Tamil", nativeName: "தமிழ்" },
    { code: "te", name: "Telugu", nativeName: "తెలుగు" },
    { code: "th", name: "Thai", nativeName: "ไทย" },
    { code: "tr", name: "Turkish", nativeName: "Türkçe" },
    { code: "uk", name: "Ukrainian", nativeName: "Українська" },
    { code: "ur", name: "Urdu", nativeName: "اردو", rtl: true },
    { code: "uz", name: "Uzbek", nativeName: "Oʻzbek" },
    { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
    { code: "cy", name: "Welsh", nativeName: "Cymraeg" },
    { code: "yi", name: "Yiddish", nativeName: "ייִדיש", rtl: true },
    { code: "zu", name: "Zulu", nativeName: "isiZulu" },
]
